module.exports = __webpack_public_path__ + "img/check-circle.6aecad05.svg";